import "flickity";
import $ from "jquery";
import Rails from "@rails/ujs";

import "../marketing/faq-section";
import "../marketing/officer-widget";
import "../marketing/mobile-nav";
import "../marketing/email-confirmation";
import "../marketing/dependent-field";
import "../shared/helpers/select-wrapper";

Rails.start();

$(".flash-close").click(() => {
  $(".flash-message").css("display", "none");
});
